import CommonFunctions from "../../../wwwroot_src/src/GlobalScripts/CommonFunctions";

/**
 * Renders the CSS-card preview for a template inside the picker dialog.
 */
function buildPreviewCard(name: string, fileName: string, title: string, description: string, accentColor: string, previewHtml: string): string {
    return `
        <div class="nl-template-card" data-filename="${fileName}" tabindex="0" role="button" aria-label="${kendo.htmlEncode(title)}">
            <div class="nl-template-preview" style="border-top:4px solid ${accentColor};">
                ${previewHtml}
            </div>
            <div class="nl-template-info">
                <strong class="nl-template-title">${kendo.htmlEncode(title)}</strong>
                <span class="nl-template-desc">${kendo.htmlEncode(description)}</span>
            </div>
        </div>`;
}

const TEMPLATES: { fileName: string; title: string; description: string; accentColor: string; previewHtml: string }[] = [
    {
        fileName: "newsletterAnnouncement.html",
        title: "Ankündigung",
        description: "Hero-Banner, Fliesstext und Call-to-Action-Button. Ideal für Ankündigungen.",
        accentColor: "#2C6FAC",
        previewHtml: `
            <div style="background:#2C6FAC;padding:14px 12px 10px;text-align:center;">
                <div style="width:60%;height:8px;background:rgba(255,255,255,0.5);border-radius:3px;margin:0 auto 6px;"></div>
                <div style="width:85%;height:5px;background:rgba(255,255,255,0.3);border-radius:3px;margin:0 auto;"></div>
            </div>
            <div style="padding:10px 12px;">
                <div style="height:5px;background:#e0e0e0;border-radius:3px;margin-bottom:5px;width:95%;"></div>
                <div style="height:5px;background:#e0e0e0;border-radius:3px;margin-bottom:5px;width:80%;"></div>
                <div style="height:5px;background:#e0e0e0;border-radius:3px;margin-bottom:10px;width:88%;"></div>
                <div style="display:inline-block;background:#2C6FAC;padding:5px 14px;border-radius:3px;">
                    <div style="height:4px;width:48px;background:rgba(255,255,255,0.8);border-radius:2px;"></div>
                </div>
            </div>`
    },
    {
        fileName: "newsletterNewsletter.html",
        title: "Newsletter",
        description: "Hauptartikel mit Sidebar. Für regelmässige Newsletter-Ausgaben.",
        accentColor: "#2C6FAC",
        previewHtml: `
            <div style="background:#2C6FAC;padding:10px 12px;">
                <div style="width:70%;height:7px;background:rgba(255,255,255,0.6);border-radius:3px;margin-bottom:4px;"></div>
                <div style="width:40%;height:4px;background:rgba(255,255,255,0.3);border-radius:3px;"></div>
            </div>
            <div style="display:flex;padding:10px 12px;gap:8px;">
                <div style="flex:3;">
                    <div style="height:5px;background:#2C6FAC;border-radius:2px;width:55%;margin-bottom:6px;"></div>
                    <div style="height:4px;background:#e0e0e0;border-radius:2px;margin-bottom:4px;width:95%;"></div>
                    <div style="height:4px;background:#e0e0e0;border-radius:2px;margin-bottom:4px;width:85%;"></div>
                    <div style="height:4px;background:#e0e0e0;border-radius:2px;width:90%;"></div>
                </div>
                <div style="flex:2;border-left:2px solid #e0e0e0;padding-left:8px;">
                    <div style="height:4px;background:#ddd;border-radius:2px;margin-bottom:5px;width:80%;"></div>
                    <div style="height:4px;background:#ddd;border-radius:2px;margin-bottom:5px;width:70%;"></div>
                    <div style="height:4px;background:#ddd;border-radius:2px;width:75%;"></div>
                </div>
            </div>`
    },
    {
        fileName: "newsletterProducts.html",
        title: "Produktübersicht",
        description: "Drei Produktkarten nebeneinander. Perfekt für Angebote und Highlights.",
        accentColor: "#2C6FAC",
        previewHtml: `
            <div style="background:#2C6FAC;padding:12px;text-align:center;">
                <div style="width:60%;height:7px;background:rgba(255,255,255,0.5);border-radius:3px;margin:0 auto;"></div>
            </div>
            <div style="display:flex;padding:10px 8px;gap:6px;">
                ${[1, 2, 3].map(() => `
                    <div style="flex:1;background:#f0f6fc;border-radius:3px;overflow:hidden;">
                        <div style="height:3px;background:#2C6FAC;"></div>
                        <div style="padding:6px 6px;">
                            <div style="height:4px;background:#2C6FAC;border-radius:2px;opacity:0.5;margin-bottom:4px;width:60%;"></div>
                            <div style="height:5px;background:#333;border-radius:2px;margin-bottom:5px;width:75%;opacity:0.4;"></div>
                            <div style="height:3px;background:#aaa;border-radius:2px;margin-bottom:3px;width:90%;"></div>
                            <div style="height:3px;background:#aaa;border-radius:2px;width:70%;"></div>
                        </div>
                    </div>`).join("")}
            </div>`
    }
];

export default class NewsletterTemplatePicker {

    static openPicker(se: any): void {
        const editorElement = $(se.sender.element)
            .closest(".kendo-text-editor-wrapper")
            .find(".k-editor");
        const actionUrl = editorElement.data("insertstandardtemplate") as string;
        const editor: kendo.ui.Editor = editorElement.data("kendoEditor") || editorElement.data("kendoOrphyEditor");

        const cardsHtml = TEMPLATES.map(t =>
            buildPreviewCard(t.fileName, t.fileName, t.title, t.description, t.accentColor, t.previewHtml)
        ).join("");

        const dialogHtml = `
            <div class="nl-picker-dialog">
                <div class="nl-template-grid">${cardsHtml}</div>
            </div>`;

        const windowEl = $("<div class='nl-picker-window'></div>").html(dialogHtml).appendTo("body");

        // Bind card handlers once, before kendoWindow is created — avoids the
        // open callback firing on both init and .open(), which would attach them twice.
        windowEl.find(".nl-template-card").on("click keydown", function (e: JQuery.TriggeredEvent) {
            if (e.type === "keydown" && (e as JQuery.KeyDownEvent).key !== "Enter") { return; }
            const fileName = $(this).data("filename") as string;
            kendoWindow.close();

            const currentValue = editor.value();
            const doInsert = () => {
                CommonFunctions.getWithData(actionUrl, { name: fileName }, (content: string) => {
                    editor.value(content);
                });
            };

            if (currentValue && currentValue.trim().length > 0) {
                CommonFunctions.showConfirm(
                    TextResources.Views_Vorlagen,
                    TextResources.Views_OverwriteWithTemplate,
                    doInsert,
                    () => { /* cancelled */ }
                );
            } else {
                doInsert();
            }
        });

        const kendoWindow = windowEl.kendoWindow({
            title: TextResources.Views_Vorlagen,
            modal: true,
            resizable: false,
            width: 680,
            deactivate() { kendoWindow.destroy(); }
        }).data("kendoWindow");

        kendoWindow.center().open();
    }
}
